import { gql } from '@apollo/client';

export const SIGN_IN = gql`
    mutation SignIn($email: String!, $password: String!) {
        authenticateUserWithPassword(email: $email, password: $password) {
            ... on UserAuthenticationWithPasswordSuccess {
                sessionToken
                item {
                    id
                    email
                    name
                    role
                }
            }
            ... on UserAuthenticationWithPasswordFailure {
                message
            }
        }
    }
`;

export interface AuthenticateUserWithPasswordResponse {
    authenticateUserWithPassword:
        | {
              __typename: 'UserAuthenticationWithPasswordSuccess';
              sessionToken: string;
              item: {
                  id: string;
                  email: string;
                  name: string;
                  role: string;
              };
          }
        | {
              __typename: 'UserAuthenticationWithPasswordFailure';
              message: string;
          };
}

export const OAUTH_GOOGLE = gql`
    mutation AuthenticateWithGoogle($token: String!) {
        authenticateWithGoogle(token: $token) {
            ... on AuthenticateWithGoogleSuccess {
                sessionToken
                item {
                    id
                    email
                    name
                    role
                }
            }
            ... on SignUpWithGoogleSuccess {
                sessionToken
                item {
                    id
                    email
                    name
                    role
                }
            }
            ... on AuthenticateWithGoogleFailure {
                message
            }
        }
    }
`;

export interface AuthorizeWithGoogleResponse {
    authenticateWithGoogle:
        | {
              __typename: 'AuthenticateWithGoogleSuccess' | 'SignUpWithGoogleSuccess';
              sessionToken: string;
              item: {
                  id: string;
                  email: string;
                  name: string;
                  role: string;
              };
          }
        | {
              __typename: 'AuthenticateWithGoogleFailure';
              message: string;
          };
}

export const SIGN_UP = gql`
    mutation RequestSignUp($data: VerifyAndCreateUserInput!) {
        requestSignUp(data: $data) {
            ... on RequestSignUpFailure {
                message
            }
            ... on RequestSignUpSuccess {
                success
            }
        }
    }
`;

export const RESEND_VERIFICATION_EMAIL = gql`
    mutation ResendVerificationEmail($data: VerifyAndCreateUserInput!) {
        resendVerificationEmail(data: $data)
    }
`;

export const SEND_USER_PASSWORD_RESET_LINK = gql`
    mutation SendUserPasswordResetLink($email: String!) {
        sendUserPasswordResetLink(email: $email)
    }
`;

export interface RedeemUserPasswordResetTokenResponse {
    redeemUserPasswordResetToken?: {
        code?: string;
        message?: string;
    };
}

export const REDEEM_USER_PASSWORD_RESET_TOKEN = gql`
    mutation RedeemUserPasswordResetToken($email: String!, $token: String!, $password: String!) {
        redeemUserPasswordResetToken(email: $email, token: $token, password: $password) {
            code
            message
        }
    }
`;

export const UPDATE_USER_PASSWORD = gql`
    mutation updateUserPassword($currentPassword: String!, $newPassword: String!) {
        updateUserPassword(currentPassword: $currentPassword, newPassword: $newPassword)
    }
`;
